import React, {Component} from 'react';
import ReactSVG from 'react-svg';
import { injectIntl, FormattedMessage } from 'react-intl';
import Gallery from './../../components/gallery/Gallery';
import PlaceCard from './../../components/placeCard/PlaceCard';
import NavigationBar from './../../components/navigationBar/NavigationBar';
import Input from '../../components/input/Input';
import {getDistanceFromPoints} from './../../utils/Utils';
import {newDateTime} from './../../utils/Utils';
import {removeAccents} from './../../utils/Utils';
import ProgressiveImage from 'react-progressive-image';

import AuthResources from './../../resourcers/authResources';

import SearchIcon from './../../assets/img/search.svg';
import SettingsIcon from './../../assets/img/settings.svg';
import BackArrow from './../../assets/img/arrow_small.svg';
import Placeholder from './../../assets/img/placeholder1.jpg';

import styles from './HomeScreen.module.css';

class HomeScreen extends Component {

    authResources = new AuthResources();

    constructor(props){
        super(props);
        this.intl = this.props.intl;
        this.inputRef = React.createRef();

        this.state = {
            pageTransitionEnd: false,
            inputFullscreen: "hidden",
            inputType: "places",
            inputValue: ""
        }

        window.scrollTo(0,0);
        document.body.classList.remove("purpleBackground");

        this.animationEnd = this.animationEnd.bind(this);
        this.hideInputFullscreen = this.hideInputFullscreen.bind(this);
        this.calculateDistance = this.calculateDistance.bind(this);
        this.setInputValue = this.setInputValue.bind(this);
        this.updateFilter = this.updateFilter.bind(this);
        this.goToSettings = this.goToSettings.bind(this);
        this.goToEventList = this.goToEventList.bind(this);
        this.goToEventDetails = this.goToEventDetails.bind(this);
        this.goToPlacesList = this.goToPlacesList.bind(this);
        this.goToPlaceDetails = this.goToPlaceDetails.bind(this);
        this.openInputFullscreen = this.openInputFullscreen.bind(this);
        this.closeInputFullscreen = this.closeInputFullscreen.bind(this);
        this.renderEvents = this.renderEvents.bind(this);
        this.renderHighlights = this.renderHighlights.bind(this);
        this.renderCultural = this.renderCultural.bind(this);
        this.renderNatural = this.renderNatural.bind(this);
        this.renderEventsOptions = this.renderEventsOptions.bind(this);
        this.renderPlacesOptions = this.renderPlacesOptions.bind(this);
        this.renderFullscreenInput = this.renderFullscreenInput.bind(this)
    }

    componentDidMount() {
        this.props.requestGeolocation();
    }

    hideInputFullscreen() {
        if(this.state.inputFullscreen === "close"){
            this.setState({
                inputFullscreen: "hidden"
            });
        }
    }

    goToSettings() {
        this.props.history.push('/settings');
    }

    goToEventList() {
        this.props.history.push({
            pathname: '/eventList',
            state: {
                animation: "slideInRight"
            }
        });
    }

    goToEventDetails(eventName) {
        this.props.history.push({
            pathname: '/eventDetails/' + eventName,
            state: {
                animation: "slideInRight"
            }
        });
    }

    goToPlacesList(category) {
        this.props.history.push({
            pathname: '/placesList/' + category,
            state: {
                animation: "slideInRight"
            }
        });
    }

    goToPlaceDetails(placeId) {
        this.props.history.push({
            pathname: '/placeDetails/' + placeId,
            state: {
                animation: "slideInRight"
            }
        });
    }

    animationEnd() {
        this.setState({
            pageTransitionEnd: true
        });
    }

    calculateDistance(place) {
        if(place.location && this.props.coords) {
            let userLat = this.props.coords.lat;
            let userLong = this.props.coords.long;
            let placeLat = place.location.lat;
            let placeLong = place.location.lng;
            let distance = getDistanceFromPoints(userLat, userLong, placeLat, placeLong);

            return distance;
        }
    }

    openInputFullscreen(){
        if(this.state.inputFullscreen !== "open"){
            this.setState({
                inputFullscreen: "open",
                inputValue: ""
            });
        }
    }

    closeInputFullscreen(){
        this.setState({
            inputFullscreen: "close",
            inputValue: ""
        })
    }

    setInputValue(e) {
        let inputType = this.state.inputType, allPlaces = [];
        Object.keys(this.props.places).forEach(key => {
            if(key !== "highlights"){
                this.props.places[key].map(place => {
                    allPlaces.push(place);
                });
            }
        });

        let placesFiltered = allPlaces.filter(option => {
                            return option["name"].toLowerCase().includes(e.target.value.toLowerCase()) ||
                                    option["desc"].toLowerCase().includes(e.target.value.toLowerCase())
                        });
        let eventsFiltered = this.props.events.filter(option => {
                                return option["event_name"].toLowerCase().includes(e.target.value.toLowerCase()) ||
                                    option["description"].toLowerCase().includes(e.target.value.toLowerCase())
                        });

        if(this.state.inputType === "events" && placesFiltered.length > 0){
            inputType = "places";
        }else{
            if(this.state.inputType === "places" && placesFiltered.length === 0 && eventsFiltered.length > 0){
                inputType =  "events";
            }else{
                if(this.state.inputType === "events" && eventsFiltered.length === 0 && placesFiltered.length > 0){
                    inputType = "places";
                }
            }
        }

        this.setState({
            inputValue: e.target.value,
            inputType: inputType
        });
    }

    updateFilter(type) {
        this.setState({
            inputType: type
        });
    }

    renderPlacesOptions(options) {
        return (
            <div ref={this.optionListDidMount} id="inputOptions" className={styles.inputOptions}>
                {options
                    .sort((a,b) => {
                        let nameA = a["name"].toLowerCase();
                        let nameB = b["name"].toLowerCase();
                        return (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0;
                    })
                    .map(option => {
                        return (
                            <div key={option._id} onClick={() => this.goToPlaceDetails(option["id"])} className={styles.optionContainer}>
                                <div className={styles.optionInfoContainer}>
                                    <h4 className={styles.h4Bold}>
                                        {option["name"]}
                                    </h4>
                                    <p>
                                        {option["address"]}
                                    </p>
                                    <span className={styles.textLink}>
                                        {option["opening_hours"]}
                                    </span>
                                </div>
                                <div className={styles.optionArrowContainer}>
                                    <div className={styles.optionArrow}>
                                        <ReactSVG src={BackArrow} />
                                    </div>
                                </div>
                            </div>
                        );
                })}
            </div>
        );
    }

    renderEventsOptions(options) {
        return (
            <div ref={this.optionListDidMount} id="inputOptions" className={styles.inputOptions}>
                {options
                    .map(option => {
                        let date = newDateTime(option["start_date"]);
                        date = date.toLocaleDateString(this.intl.locale, {
                            hour12: true,
                            weekday: "short",
                            month: "short",
                            day: "numeric"
                        }).replace('de', '');

                        date = date.charAt(0).toUpperCase() + date.slice(1);

                        return (
                            <div key={option._id} onClick={() => this.goToEventDetails(option["event_name_normalize"])} className={styles.optionContainer}>
                                <div className={styles.optionInfoContainer}>
                                    <h4 className={styles.h4Bold}>
                                        {option["event_name"]}
                                    </h4>
                                    <p>
                                        {option["event_location"]}
                                    </p>
                                    <span className={styles.textLink}>
                                        {date}
                                    </span>
                                </div>
                                <div className={styles.optionArrowContainer}>
                                    <div className={styles.optionArrow}>
                                        <ReactSVG src={BackArrow} />
                                    </div>
                                </div>
                            </div>
                        );
                })}
            </div>
        );
    }

    renderFullscreenInput() {
        if(this.props.places && this.props.events){
            let animation, optionsFiltered, placesFiltered, eventsFiltered;

            if(this.state.inputFullscreen === "hidden"){
                animation = styles.fullscreenHidden;
            }
            if(this.state.inputFullscreen === "open"){
                animation = "animated fadeIn";
            }
            if(this.state.inputFullscreen === "close"){
                animation = "animated fadeOut";
            }

            if(this.state.inputValue === ""){
                return (
                    <div className={[styles.fullscreen, animation].join(' ')} onAnimationEnd={this.hideInputFullscreen}></div>
                );
            }

            let optionList, placeActive, eventActive;

            if(this.state.inputFullscreen !== "hidden"){
                let allPlaces = [];
                Object.keys(this.props.places).forEach(key => {
                    if(key !== "highlights"){
                        this.props.places[key].map(place => {
                            allPlaces.push(place);
                        });
                    }
                });

                let searchValue = removeAccents(this.state.inputValue.toLowerCase().trim());

                placesFiltered = allPlaces.filter(option => {
                                    return removeAccents(option["name"].toLowerCase()).includes(searchValue) ||
                                           removeAccents(option["desc"].toLowerCase()).includes(searchValue)
                                });
                eventsFiltered = this.props.events.filter(option => {
                                     return removeAccents(option["event_name"].toLowerCase()).includes(searchValue) ||
                                            removeAccents(option["description"].toLowerCase()).includes(searchValue)
                                });

                if(this.state.inputType === "places") {
                    optionsFiltered = placesFiltered;
                }
                if(this.state.inputType === "events") {
                    optionsFiltered = eventsFiltered;
                }

                if(this.state.inputType === "places"){
                    placeActive = styles.filterActive;
                    optionList = this.renderPlacesOptions(placesFiltered);
                }
                if(this.state.inputType === "events"){
                    eventActive = styles.filterActive;
                    optionList = this.renderEventsOptions(eventsFiltered);
                }

                if(optionsFiltered.length === 0){
                    optionList = (
                        <div className={styles.optionNotFound}>
                            <span className={styles.sadFace}>
                                :(
                            </span>
                            <br/>
                            <br/>
                            <div className={styles.notFoundText}>
                                <FormattedMessage id="searchNotFound1" />
                                <br/>
                                <FormattedMessage id="searchNotFound2" />
                            </div>
                        </div>
                    );
                }
            }

            return (
                <div className={[styles.fullscreen, animation].join(' ')} onAnimationEnd={this.hideInputFullscreen}>
                    <div className={styles.filtersContainer}>
                        <div onClick={() => this.updateFilter("places")} className={[styles.filterOption, placeActive].join(' ')}>
                            <FormattedMessage id="places" /> ({placesFiltered.length})
                        </div>
                        <div onClick={() => this.updateFilter("events")} className={[styles.filterOption, eventActive].join(' ')}>
                            <FormattedMessage id="events" /> ({eventsFiltered.length})
                        </div>
                    </div>
                    {optionList}
                </div>
            );
        }
    }

    renderHeader() {
        let animation = "", element, smallSearch, searchIcon, searchPlaceholder = this.intl.formatMessage({id: "searchPlaceholder"});

        if(this.state.inputFullscreen === "open"){
            element = (
                <span className={styles.cancelButton} onClick={this.closeInputFullscreen}>
                    <FormattedMessage id="cancel" />
                </span>
            );
            smallSearch = styles.smallSearch;
            animation = "animated fadeIn delay-transition";
        }else{
            element = <ReactSVG src={SettingsIcon} className={styles.settingsIcon} onClick={this.goToSettings} />;
            searchIcon = <ReactSVG src={SearchIcon} />;
        }

        return (
            <div className={styles.header}>
                <div className={[styles.searchContainer, smallSearch].join(' ')}>
                    <div className={styles.searchInput} onClick={this.openInputFullscreen}>
                        {searchIcon}
                        <Input noLine={true} placeholder={searchPlaceholder} value={this.state.inputValue} inputClassName={styles.searchInputText} onChange={this.setInputValue}/>
                    </div>
                </div>
                <div className={animation}>
                    {element}
                </div>
            </div>
        );
    }

    renderHighlights() {
        if(this.props.places){

            let places = this.props.places['highlights'];

            let highlights = places;

            if(this.props.coords){
                places.forEach(place => {
                    place.distance = this.calculateDistance(place);
                });
                highlights = places.sort((a, b) => {return a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0;});
            }

            highlights = highlights
                .slice(0, 5)
                .map((place, i) => {
                    return (
                        <PlaceCard  key={i}
                                    onClick={() => this.goToPlaceDetails(place.id)}
                                    coords={this.props.coords}
                                    resize="928x868"
                                    className={styles.highlightCard}
                                    imageClassName={styles.highlightImage}
                                    cardInfo={place}/>
                    );
                });

            // highlights.unshift((
            //     <PlaceCard className={styles.highlightCard}
            //                cardInfo={{
            //                     imgs: ["https://portaldoamazonas.com.br/wp-content/uploads/2016/02/Teatro-Amazonas-1024x768.jpg"],
            //                     name: "MAPA AR"
            //                }}
            //     />
            // ));

            return (
                <div className={[styles.section, styles.highlightsSection].join(' ')}>
                    <div className={styles.sectionHeader}>
                        <h4 className="h4Bold"><FormattedMessage id="highlight" /></h4>
                        <p onClick={() => this.goToPlacesList("highlights")}><FormattedMessage id="seeAll" /></p>
                    </div>
                    <Gallery images={highlights} className={styles.galleryContainer}/>
                </div>
            );
        }
    }

    renderEvents() {
        if(this.props.events){
            let list = this.props.events;

            let events = list
                            .filter(event => newDateTime(event.start_date) >= new Date().setHours(0,0,0,0) ||
                                             new Date().setHours(0,0,0,0) <= newDateTime(event.end_date))
                            .sort(function(e1, e2){
                                return new Date(e1.start_date) - new Date(e2.start_date);
                            });

            let sliceIndex = 5;
            if(events.length < 5){
                sliceIndex = events.length;
            }

            events = events.sort((a,b) => {return newDateTime(a.start_date) - newDateTime(b.start_date)})
                           .slice(0, sliceIndex)
                           .map((event, i) => {

                let date = newDateTime(event.start_date);
                date = date.toLocaleDateString(this.intl.locale, {
                    hour12: true,
                    weekday: "short",
                    month: "short",
                    day: "numeric"
                }).replace('de', '');

                date = date.charAt(0).toUpperCase() + date.slice(1);

                let image;
                if(event.banner_url !== ""){
                    image = (
                        <ProgressiveImage src={event.banner_url} placeholder={event.banner_url}>
                            {(src, loading) => <img src={src} alt="an image" style={{ opacity: loading ? 0 : 1 }} className={styles.eventCardImage}/>}
                        </ProgressiveImage>
                    );
                }else{
                    image = <img src={Placeholder} className={styles.eventCardImage} />;
                }

                return (
                    <div onClick={() => this.goToEventDetails(event.event_name_normalize)}>
                        <div key={i} className={styles.eventCard}>
                            {image}
                        </div>
                        <p className={styles.eventHour}>{date}</p>
                        <h6 className={styles.eventName}>{event.event_name}</h6>
                    </div>
                );
            });
            return (
                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <h4 className="h4Bold"><FormattedMessage id="eventsNearby" /></h4>
                        <p onClick={() => this.goToEventList()}><FormattedMessage id="seeAll" /></p>
                    </div>
                    <div className={[styles.horizontalContainer, styles.eventsContainer].join(' ')}>
                        {events}
                    </div>
                </div>
            );
        }
    }

    renderCultural() {
        if(this.props.places){
            let list = this.props.places['culturais'];

            if(this.props.coords){
                list.forEach(place => {
                    place.distance = this.calculateDistance(place);
                });

                list = list.sort((a, b) => {return a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0;})
            }

            let places = list
                .slice(0, 5).map((place, i) => {
                return (
                    <div key={i} className={styles.placeCard} onClick={() => this.goToPlaceDetails(place.id)}>
                        <ProgressiveImage src={place.imgs[0].replace("images", "images/475x462")} placeholder={place.imgs[0].replace("images", "images/275x262")}>
                            {(src, loading) => <img src={src} alt="an image" style={{ opacity: loading ? 0 : 1 }} className={styles.placeCardImage}/>}
                        </ProgressiveImage>
                        <h6>{place.name}</h6>
                    </div>
                );
            });
            return (
                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <h4 className="h4Bold"><FormattedMessage id="culturalPlaces" /></h4>
                        <p onClick={() => this.goToPlacesList("culturais")}><FormattedMessage id="seeAll" /></p>
                    </div>
                    <div className={styles.horizontalContainer}>
                        {places}
                    </div>
                </div>
            );
        }
    }

    renderNatural() {
        if(this.props.places){
            let list = this.props.places['naturais'];

            if(this.props.coords){
                list.forEach(place => {
                    place.distance = this.calculateDistance(place);
                });

                list = list.sort((a, b) => {return a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0;})
            }

            let places = list
                .slice(0, 5).map((place, i) => {
                return (
                    <div key={i} className={styles.placeCard} onClick={() => this.goToPlaceDetails(place.id)}>
                        <ProgressiveImage src={place.imgs[0].replace("images", "images/475x462")} placeholder={place.imgs[0].replace("images", "images/275x262")}>
                            {(src, loading) => <img src={src} alt="an image" style={{ opacity: loading ? 0 : 1 }} className={styles.placeCardImage}/>}
                        </ProgressiveImage>
                        <h6>{place.name}</h6>
                    </div>
                );
            });
            return (
                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <h4 className="h4Bold"><FormattedMessage id="naturalPlaces" /></h4>
                        <p onClick={() => this.goToPlacesList("naturais")}><FormattedMessage id="seeAll" /></p>
                    </div>
                    <div className={styles.horizontalContainer}>
                        {places}
                    </div>
                </div>
            );
        }
    }

    render(){
        let animation = "";
        if(!this.state.pageTransitionEnd && this.props.location.state && this.props.location.state.animation)
        {
            animation = "animated " + this.props.location.state.animation;
        }

        return (
            <div>
                <NavigationBar history={this.props.history} fixed={true} active={"explore"} />
                {this.renderFullscreenInput()}
                <div className={[styles.content, animation].join(' ')} onAnimationEnd={this.animationEnd}>
                    {this.renderHeader()}
                    {this.renderHighlights()}
                    {this.renderEvents()}
                    {this.renderCultural()}
                    {this.renderNatural()}
                </div>
            </div>
        );
    }

}

export default injectIntl(HomeScreen);